import { Box, makeStyles, TableCell, TableRow, Typography } from "@material-ui/core";
import { useParams } from "react-router-dom";
import Brightness1Icon from "@material-ui/icons/Brightness1";
import Highcharts from "highcharts";
import { formatAddress, numberWithCommas, toFixed } from "src/services/utils";
import ExternalLinkButton from "src/components/Button/ExternalLinkButton";
import { EXPLORER_TYPE } from "src/hooks/useExplorerUrl";

const useStyle = makeStyles((theme) => ({
  firstCell: {
    position: "sticky",
    left: 0,
    zIndex: 1,
    backgroundColor: theme.palette.background.paper,
  },
  cell: {
    cursor: "pointer",
  },
}));

export default function TransactionRow({ rowData }) {
  const cls = useStyle();
  const { pool } = useParams();

  return (
    <TableRow>
      <TableCell className={cls.firstCell}>
        <Box display="flex" justifyContent="flex-start" alignItems="center">
          <Brightness1Icon style={{ color: rowData.color, fontSize: "16px", marginRight: "0.25rem" }} />
          <Typography>{rowData["event_type"]}</Typography>
        </Box>
      </TableCell>
      <TableCell className={cls.cell}>
        <Typography>{Highcharts.dateFormat("%b %e, %Y, %k:%M", rowData["timestamp"] * 1000)}</Typography>
      </TableCell>
      <TableCell className={cls.cell}>
        <Typography>{`$${numberWithCommas(toFixed(rowData["amount"], 2))}`}</Typography>
      </TableCell>
      <TableCell className={cls.cell}>
        <Box display="flex" justifyContent="flex-start" alignItems="center">
          <Typography>{formatAddress(rowData["user"], 3)}</Typography>
          <ExternalLinkButton hash={rowData["user"]} config={{ pool }} />
        </Box>
      </TableCell>
      <TableCell className={cls.cell}>
        <Box display="flex" justifyContent="flex-start" alignItems="center">
          <Typography>{rowData["symbol"]}</Typography>
          <ExternalLinkButton hash={rowData["token"]} config={{ pool }} />
        </Box>
      </TableCell>
      <TableCell className={cls.cell}>
        <Box display="flex" justifyContent="flex-start" alignItems="center">
          <Typography>{formatAddress(rowData["tx_hash"], 3)}</Typography>
          <ExternalLinkButton hash={rowData["tx_hash"]} config={{ pool, type: EXPLORER_TYPE.TRANSACTION }} />
        </Box>
      </TableCell>
    </TableRow>
  );
}
